import { render } from "./TransactionsList.vue?vue&type=template&id=853005a8&scoped=true"
import script from "./TransactionsList.vue?vue&type=script&lang=js"
export * from "./TransactionsList.vue?vue&type=script&lang=js"

import "./TransactionsList.vue?vue&type=style&index=0&id=853005a8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-853005a8"]])

export default __exports__